// extracted by css-extract-rspack-plugin
export default {"panel":"panel-sA0VQV","link":"link-xmXXNp","subTitle":"subTitle-MtOY4z"};